// What the agent desk shows about where this phone is plugged in: the caller ID
// it presents, the teams it answers for, the numbers that reach it. They arrive
// with the credential (/ops/api/voice/softphone/credentials), so SipProvider
// keeps them beside the registration (SipContext.tsx), not the desk page: the
// desk unmounts on every navigation, and re-fetching would rotate the SIP
// password under the live registration. Kept in the page, they were lost the
// moment the agent left Agent desktop and came back, which read "on no team"
// for an agent who was on one and was ringing for it.

export interface DeskInfo {
  callerId: string | null;
  teams: string[];
  inboundNumbers: { e164: string; team: string | null }[];
}

/** The credential response, as every fetch of it reads it. */
export interface SoftphoneCredentials {
  ext: string;
  password: string;
  wss?: string;
  domain?: string;
  callerId?: string | null;
  teams?: string[];
  inboundNumbers?: { e164: string; team: string | null }[];
}

/** An older server that sends none of these reads as "unknown", not "no team". */
export function deskInfoFrom(c: SoftphoneCredentials): DeskInfo {
  return {
    callerId: c.callerId ?? null,
    teams: Array.isArray(c.teams) ? c.teams : [],
    inboundNumbers: Array.isArray(c.inboundNumbers) ? c.inboundNumbers : [],
  };
}
